import React, { useState } from 'react';
import { _, localise_enum } from 'src/utils'
import FilterStruct, { YearsSelector, Dropdown } from 'src/shared'
import { useTranslation } from 'src/contexts/TranslationContext';

export function MapsHeader (props) {
    const [mapTypeValue, setMapTypeValue] = useState("GeographicGroups");
    const {gettext} = useTranslation()

    const handleMapTypeChange = (val) => {
        setMapTypeValue(val);
        props.changeTitle(val);
    };

    return (
        <div style={{marginBottom: '20px'}}>

            <Dropdown
                label={gettext('Select a map')}
                key_value_map={localise_enum(FilterStruct.MapTypes)}
                value={mapTypeValue}
                on_change={handleMapTypeChange}
                display_values={true}
                />
            
            <YearsSelector 
                label={gettext('Select a year')}
                key_value_map={localise_enum(FilterStruct.Years)}
                start_year={[props.year[0], props.year[1]]}
                marginLeft={'10px'}
                />

            {mapTypeValue == "SpanishAutonomousCommunitiesByRegion" ? 
                <Dropdown
                    label={gettext('Select sector')}
                    key_value_map={localise_enum(FilterStruct.ESPSectors)}
                    value={props.sector[0]}
                    on_change={props.sector[1]}
                    display_values={false}
                /> : <></>}

            {mapTypeValue == "SpanishAutonomousCommunitiesBySector" ? 
                <Dropdown
                    label={gettext('Select region')}
                    key_value_map={localise_enum(FilterStruct.ESPRegions)}
                    value={props.region[0]}
                    on_change={props.region[1]}
                    display_values={false}
                /> : <></>}

        </div>
    )
}
  